import React from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'

export default function CreateOrganizationPopupTitle({ title, subtitle = '' }) {
  return (
    <>
      <h2 className={classes.title}>{title}</h2>
      {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
    </>
  )
}

CreateOrganizationPopupTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
}
